import scriptLoader from './scriptLoader';
import loadingMessageManager from './loadingMessageManager';
// import serviceWorkersInitializer from './serviceWorkersInitializer';

loadingMessageManager.init();
scriptLoader.load();

// TODO: need to enable it in scope of IA1-4806
// serviceWorkersInitializer.init();
